// extracted by mini-css-extract-plugin
export default {"wrap":"mdZtB","messagePopover":"htLV6","messagePopoverPadding":"lLXXe","reactionsWrapper":"j8RIk"};